/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Suggestions_Welcome_6Inputs */

const es_chat_suggestions_welcome_6 = /** @type {(inputs: Chat_Suggestions_Welcome_6Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estoy listo para ayudarte, ${i?.name}. ¿Cómo empezamos?`)
};

const en_chat_suggestions_welcome_6 = /** @type {(inputs: Chat_Suggestions_Welcome_6Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I'm here to help, ${i?.name}. How should we begin?`)
};

/**
* | output |
* | --- |
* | "I'm here to help, {name}. How should we begin?" |
*
* @param {Chat_Suggestions_Welcome_6Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_suggestions_welcome_6 = /** @type {((inputs: Chat_Suggestions_Welcome_6Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestions_Welcome_6Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_suggestions_welcome_6(inputs)
	return en_chat_suggestions_welcome_6(inputs)
});
export { chat_suggestions_welcome_6 as "chat.suggestions.welcome_6" }